module.exports = new __parcel__URL__("12472_sq.89cb9957.jpg").toString();